import { render, staticRenderFns } from "./LabPage.vue?vue&type=template&id=711224fc&scoped=true&"
import script from "./LabPage.vue?vue&type=script&lang=js&"
export * from "./LabPage.vue?vue&type=script&lang=js&"
import style0 from "./LabPage.vue?vue&type=style&index=0&id=711224fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711224fc",
  null
  
)

export default component.exports